import React from "react";
import { ICalendarDay, ICalendarDayService } from "dataModels/b2b";
import { Row, Col } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { TimePicker } from "@ds/ds-snam/react";
import styles from "views/b2bView/styles/calendarSettingsFormStyles.module.css";
import { CalendarDayServiceType } from "dataModels/b2b";
import { v4 as uuid } from "uuid";
import { transformTime } from "shared/utils/dateUtils";
import moment from "moment";
import { AppUserRole, DsLayout, IAppUserProfile, TIME_FORMAT } from "shared/constants";
import { useSelector } from "react-redux";
import { RootState } from "state/appStore";
import { AppUser } from "ooAuth2/appUser";
import useAppUser from "hooks/useAppUser";

interface ICalendarSettingsFormDataInputProps {
    formData: ICalendarDay,
    onTimeInputChange: (value: string, fieldName: string) => void,
    onServiceTimeInputChange: (value: string, fieldName: string, serviceType: number) => void
}
export const CalendarSettingsFormDataInput: React.FC<ICalendarSettingsFormDataInputProps> = (props) => {
    const { formData, onTimeInputChange, onServiceTimeInputChange } = props;
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const appUserProfile: IAppUserProfile | undefined = appUser?.userProfile;
    const { t } = useTranslation(['b2b']);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const getTimePickerInstance = (
        id:string, 
        label: string, 
        defaultTime: string, 
        onTimeSelection: (event: Event) => void, 
        isPanelTop: boolean = false,
        startTime?:string,
        endTime?:string,
        isDisabled: boolean = false
    ) => {
        return <TimePicker
            id={id}
            timePickerTitle={label}
            startTime={startTime?startTime:"00:00"}
            endTime={endTime?endTime:"23:59"}
            timeInterval={5}
            isDisabled={isDisabled || appUserRole===AppUserRole.READER}
            //timePickerPlaceholder="hh:mm"
            timePickerStatus="default"
            defaultTime={defaultTime}
            isPanelTop={isPanelTop}
            onTimeSelection={onTimeSelection}
        />
    }

    return <>
        <Row style={{marginBottom:'12px'}}>
            <Col>
                <p className={styles.formSectionTitle} style={{color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                    {/*Impostazioni giorno*/}
                    {t("calendarSettingsForm.sections.title.0")}
                </p>
            </Col>
        </Row>
        <Row style={{marginBottom:'12px'}}>
            {/** Start day time */}
            <Col xs={12} md={4}>
                {/** Orario inizio giornata */}
                {getTimePickerInstance(
                    "startTime",
                    t("calendarSettingsForm.timeInputLabels.0") + "*",
                    formData?.startTime, 
                    (event: Event) => {
                        onTimeInputChange((event as CustomEvent).detail.time, "startTime")
                    })}
            </Col>
            {/** End day time */}
            <Col xs={12} md={4}>
                {/**Orario fine giornata*/ }
                {getTimePickerInstance(
                    "endTime",
                    t("calendarSettingsForm.timeInputLabels.1") + "*",
                    formData?.endTime, 
                    (event: Event) => {
                        onTimeInputChange((event as CustomEvent).detail.time, "endTime")
                    },
                    undefined,
                    //(moment.unix(transformTime(formData?.startTime))//original
                    formData.startTime==="00:00"?"00:00":(moment.unix(transformTime(formData?.startTime))//Change req  of jul 04, 2024
                    .add(5, "minutes")
                    .format(TIME_FORMAT))//set end time limit = start time+5 min, only if start time is not 0 (otherwise this will be 0 too)
                )}
            </Col>
        </Row>

        <Row style={{marginBottom:'12px'}}>
            <Col>
                <p className={styles.formSectionTitle} style={{color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                    {/*Servizi per bande orarie*/}
                    {t("calendarSettingsForm.sections.title.1")}
                </p>
            </Col>
        </Row>
        {Object.values(CalendarDayServiceType)
            .filter((serviceType: string | CalendarDayServiceType) => { return !isNaN(Number(serviceType)) })
            .map((serviceType: string | CalendarDayServiceType) => {
                //console.log(formData?.services[Number(serviceType)], serviceType)
                const serviceObj: ICalendarDayService = formData?.services[Number(serviceType)];
                return (<>
                    {serviceObj.available && <Row key={uuid()} className={styles.row}>
                        <Col xs={12} md={2}>
                            <div style={{ display: "flex", alignItems: "center", height: "100%"}}>
                                <p className={styles.rowLabel} style={{color:layoutMode===DsLayout.DARK_MODE?"white":"black",paddingTop:'27px' }}>
                                    {t("calendarSettingsForm.fields." + serviceObj.service)}
                                </p>
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            {/** Orario inizio */}
                            {getTimePickerInstance(
                                "startTime-service",
                                t("calendarSettingsForm.timeInputLabels.2") + "*",
                                serviceObj.startTime, 
                                (event: Event) => {
                                    onServiceTimeInputChange((event as CustomEvent).detail.time, "startTime", serviceObj.service)
                                },
                                (Number(serviceType) + 1) >= 6,/*,
                                formData.startTime,
                                formData.endTime*/
                                undefined,
                                undefined,
                                !serviceObj.available
                            )}
                        </Col>
                        <Col xs={12} md={4}>
                            {/*Orario fine*/}
                            {getTimePickerInstance(
                                "endTime-service",
                                t("calendarSettingsForm.timeInputLabels.3") + "*",
                                serviceObj.endTime, 
                                (event: Event) => {
                                    onServiceTimeInputChange((event as CustomEvent).detail.time, "endTime", serviceObj.service)
                                },
                                (Number(serviceType) + 1) >= 6,/*,
                                formData.startTime,
                                formData.endTime*/
                                undefined,
                                undefined,
                                !serviceObj.available
                            )}
                        </Col>
                    </Row>
                    }
                    </>
                )
            })}
    </>
}

export default CalendarSettingsFormDataInput;